import { Controller } from "stimulus"
import { formatMoney, formatMoneyMillis, formatWeight } from 'formatters';
import { setupCountryCascade, setupCascade } from 'locations';
import { Settings } from 'settings.js.erb';
import { EntrySign } from 'enumerations.js.erb';

export default class extends Controller {
  static get targets() {
    return ['clientCode', 'clientFirstName', 'clientLastName', 'kind', 'destinationCompanyBankAccount', 'sign'];
  } 

  connect(){
    this.kindChanged();
  }

  clientCodeChanged(event) {
    let clientCodeField = $(this.clientCodeTarget);
    let clientCodeOption = clientCodeField.find("option:selected");
    
    if (clientCodeOption.data('firstName')) {
      $(this.clientFirstNameTarget).val(clientCodeOption.data('firstName'));
    }
    if (clientCodeOption.data('lastName')) {
      $(this.clientLastNameTarget).val(clientCodeOption.data('lastName'));
    }
  }

  kindChanged(event) {
    if ($(this.kindTarget).val() == "GIROCONTO"||$(this.kindTarget).val() == "PRELEVAMENTO") {
      $(this.destinationCompanyBankAccountTarget).closest('.form-group').show();
      $(this.signTarget).val(EntrySign.MINUS);
    } else {
      $(this.destinationCompanyBankAccountTarget).val('');
      $(this.destinationCompanyBankAccountTarget).closest('.form-group').hide();
    }
  }
}
